import React from 'react';
import {Platform, View} from 'react-native';
import {Text} from '../../../../../../shared/components/text/index.web';
import {useStyles} from '../../../../../../shared/hooks/styles';
import {images} from '../../../../../../assets/icons';
import {TouchableOpacity} from 'react-native';
import {useAccountLinker} from '../../../../../../shared/hooks/useAccountLinkerHook/useAccountLinker';
import {useModal} from '../../../../../../shared/components/modal';
import {UnlinkConfirmationModal} from './unlinkConfirmation';
import {capitalizeLastWord} from '../../../../../../shared/utils/text';

import {useAppDispatch} from '../../../../../../redux';
import {Button} from '../../../../../../shared/components/button';
import {useIsDesktop} from '../../../../../../shared/hooks/useIsDesktop';
import {useNavigation} from '@react-navigation/native';
import {Screens} from '../../../../../../shared/routing';
import {Modal} from '../../../../../../shared/components/modal/modal';
import {CustomScrollView} from '../../../../../../shared/components/scrollView';
import EsiaActivateCard from '../../../../../login/esiaActivateCard/esiaActivateCard';

type Props = {
  cardNo: string | null;
  linkedAccountHolderFullName: string;
  status: string;
  id: number;
  isParent: boolean;
};

export function LinkAccountCard(props: Props) {
  const {cardNo, linkedAccountHolderFullName, status, id, isParent} = props;
  const {acceptLinkingRequest} = useAccountLinker();
  const modals = useModal();
  const dispatch = useAppDispatch();
  const styles = useStyles(({theme}) => {
    return {
      container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: 600,
        marginBottom: 10,
      },
      clockAndNameContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        minWidth: 300,
      },
      h2: {
        ...theme.fonts.h2,
      },
      h3: {
        ...theme.fonts.h3,
      },
      bodyPending: {
        maxWidth: 260,
        ...theme.fonts.body,
        color: 'grey',
        ...theme.fonts.h5Light,
      },
      bodyAccepted: {
        maxWidth: 260,
        ...theme.fonts.body,
        ...theme.fonts.h5Light,
      },
      icon: {
        color: theme.color.textColor,
      },
      controlsItem: {
        marginLeft: 5,
      },
      controlsItemBlack: {
        marginLeft: 38.5,
        alignSelf: 'center',
      },
      leftPart: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        minWidth: 200,
        maxWidth: 200,
      },
      contentStyle: {
        paddingTop: 0,
      },
      modalTitle: {
        paddingTop: 20,
        ...theme.fonts.h3,
      },
      modalWrap: {
        paddingTop: 0,
        paddingBottom: 0,
        paddingHorizontal: 0,
        overflow: 'hidden',
        width: 878,
        margin: Platform.OS === 'ios' ? 1 : 0,
      },
    };
  });

  const declineLinkingPress = () => {
    modals.show({
      render(modal, methods) {
        const onClose = () => {
          methods.remove(modal.id);
        };
        return <UnlinkConfirmationModal id={id} onClose={onClose} fullName={linkedAccountHolderFullName} />;
      },
    });
  };

  const navigation = useNavigation();
  const isDesktopSize = useIsDesktop();
  const regCardPress = () => {
    if (isDesktopSize) {
      modals.show({
        render(modal, methods) {
          const onClose = () => {
            methods.remove(modal.id);
          };
          return (
            <Modal
              onClose={onClose}
              title={'Ваше заявление принято'}
              contentStyle={styles.contentStyle}
              titleStyle={styles.modalTitle}
              wrapStyle={styles.modalWrap}>
              <View>
                <CustomScrollView withRefresh={false} contentInsetAdjustmentBehavior='automatic'>
                  <EsiaActivateCard onCloseModal={onClose} linkedAccountIdWeb={id} />;
                </CustomScrollView>
              </View>
            </Modal>
          );
        },
      });
    } else {
      navigation.navigate(Screens.EsiaActivateCardAfterLogged);
    }
  };

  const {Close, Clock, Check} = images;

  const {linkedAccounts} = useAccountLinker();
  const linkedAccount = linkedAccounts.find((x) => x.id === id);
  const nonActivatedStatuses = [5, 6, undefined];
  const isNeedActivation =
    linkedAccount?.cardNumber == null || nonActivatedStatuses.includes(linkedAccount?.cardStatusId);

  return (
    <>
      <View testID='profile-desktop-container-id' style={styles.container}>
        <View testID='profile-desktop-container-id' style={styles.clockAndNameContainer}>
          {status === 'Pending' && isParent === false ? (
            <Clock color='rgb(238, 133, 37)' style={{minHeight: 24, minWidth: 24, marginRight: 10}} />
          ) : null}
          <View>
            <Text testID='profile-label-id' style={status === 'Pending' ? styles.bodyPending : styles.bodyAccepted}>
              {capitalizeLastWord(linkedAccountHolderFullName)}
            </Text>
          </View>
        </View>
        <View style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginLeft: 35}}>
          <View style={styles.leftPart}>
            {isNeedActivation ? (
              <View>
                <Button
                  id='notifications-description'
                  style={{width: 200}}
                  type='primary'
                  onPress={regCardPress}
                  text='Активировать карту'
                />
              </View>
            ) : (
              <Text testID='profile-label-id' style={status === 'Pending' ? styles.bodyPending : styles.bodyAccepted}>
                {`**** **** **** ${cardNo}`}
              </Text>
            )}
          </View>
          <View style={{flexDirection: 'row', marginLeft: 10}}>
            {status === 'Pending' && isParent === true ? (
              <TouchableOpacity
                testID='settings-close-check-id'
                onPress={() => {
                  acceptLinkingRequest(id.toString(), dispatch);
                }}
                style={styles.controlsItem}>
                <Check color={'green'} />
              </TouchableOpacity>
            ) : null}
            {status === 'Pending' && isParent === true ? (
              <TouchableOpacity
                testID='settings-close-check-id'
                onPress={declineLinkingPress}
                style={styles.controlsItem}>
                <Close color={'red'} />
              </TouchableOpacity>
            ) : (
              <TouchableOpacity
                testID='settings-close-check-id'
                onPress={declineLinkingPress}
                style={styles.controlsItemBlack}>
                <Close color={styles.icon.color} />
              </TouchableOpacity>
            )}
          </View>
        </View>
      </View>
    </>
  );
}
